import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameScene } from "./scenes/gameScene";

interface PhaserPathFindingDemoProps {
}

interface PhaserPathFindingDemoState {
}

const gameConfig: GameConfig = {
    title: "Path Finding Demo",
    version: "0.0.2-demo",
    backgroundColor: "#000000"
};

class PhaserPathFindingDemo extends React.Component<PhaserPathFindingDemoProps, PhaserPathFindingDemoState> {
    private game: Phaser.Game;
    constructor(props: PhaserPathFindingDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserPathFindingDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameScene} config={gameConfig} />
        </div>);
    }
}

export default PhaserPathFindingDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserPathFindingDemo/Main.tsx